<div class="title flex-center">
  <div class="title-inner text-center">
    <ng-content></ng-content>
    <img *ngIf="xButton" src="{{ xButton }}" class="icon" (click)="emit($event)" />
  </div>
</div>
